import {h} from 'ui/Framework';

export default h('svg', {
  width: '71',
  height: '14',
  viewBox: '-1 -1 73 16',
  xmlns: 'http://www.w3.org/2000/svg'
}, [
  h('g', {
    fill: 'none',
    fillRule: 'evenodd'
  }, [
    h('g', [
      h('g', [
        h('path', {
          fill: '#A3A9B2',
          d: 'M7 10.94l-4.114 2.163.785-4.581L.343 5.277l4.6-.668L7 .44 9.057 4.61l4.6.668-3.328 3.245.785 4.581zM26 10.94l-4.114 2.163.785-4.581-3.328-3.245 4.6-.668L26 .44l2.057 4.169 4.6.668-3.328 3.245.785 4.581zM45 10.94l-4.114 2.163.785-4.581-3.328-3.245 4.6-.668L45 .44l2.057 4.169 4.6.668-3.328 3.245.785 4.581z'
        }),
        h('path', {
          fill: '#D6DDE5',
          d: 'M64 10.94l-4.114 2.163.785-4.581-3.328-3.245 4.6-.668L64 .44l2.057 4.169 4.6.668-3.328 3.245.785 4.581z'
        })
      ])
    ])
  ])
]);



// WEBPACK FOOTER //
// ./src/javascripts/svg/rating-widget.es6.js